import { motion } from "framer-motion";
import { FileSpreadsheet, Database, FileWarning, Eye, Clock, Package } from "lucide-react";
import { fadeInUp, staggerContainer } from "@/lib/constants";

const problemas = [
  {
    icon: <FileSpreadsheet className="w-5 h-5" />,
    text: "Información clave en hojas de Excel sin conexión con el ERP ni con el resto de sistemas"
  },
  {
    icon: <Clock className="w-5 h-5" />,
    text: "Informes manuales que alguien actualiza cada semana copiando y pegando entre archivos"
  },
  {
    icon: <Database className="w-5 h-5" />,
    text: "ERP cargado de datos que nadie explota más allá de listados, facturas y consultas básicas"
  },
  {
    icon: <Eye className="w-5 h-5" />,
    text: "Dashboards montados hace años a los que nadie entra porque no responden preguntas reales"
  },
  {
    icon: <FileWarning className="w-5 h-5" />,
    text: "Decisiones de compras, precios o producción sin datos fiables, basadas en intuición"
  },
  {
    icon: <Package className="w-5 h-5" />,
    text: "Stock mal planificado: roturas en referencias clave y exceso de inventario en otras"
  }
];

export const ProblemasSection = () => {
  return (
    <section className="relative section-padding bg-slate-900/50" data-testid="problemas-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} className="text-center mb-12">
            <span className="text-red-400 font-medium text-sm uppercase tracking-wider">
              Síntomas técnicos habituales
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold mt-4">
              Tienes datos. Lo que falta es <span className="text-gradient">análisis real</span>
            </h2>
          </motion.div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-5xl mx-auto">
            {problemas.map((problema, index) => (
              <motion.div
                key={index}
                variants={fadeInUp}
                className="flex items-start gap-4 p-5 rounded-xl bg-slate-800/50 border border-slate-700/50 hover:border-red-500/30 transition-colors"
                data-testid={`problema-card-${index}`}
              >
                <span className="text-red-400 mt-0.5 flex-shrink-0">{problema.icon}</span>
                <span className="text-slate-300 text-sm leading-relaxed">{problema.text}</span>
              </motion.div>
            ))}
          </div>

          <motion.div variants={fadeInUp} className="mt-10 text-center">
            <div className="inline-block p-5 rounded-xl bg-indigo-600/10 border border-indigo-500/20">
              <p className="text-slate-300 text-base">
                Si te has identificado con <span className="text-white font-semibold">3 o más</span>,
                {" "}tus datos están generando coste en lugar de valor.
                <br className="hidden sm:block" />
                <span className="text-indigo-400 font-medium"> Hay solución técnica concreta para cada uno.</span>
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
